import { createSlice } from "@reduxjs/toolkit";
import { getContacts, getCompanies, getDeals, getLeads, addNewContact, updateContact, deleteContact, addNewCompanies, updateCompanies, deleteCompanies, addNewLead, updateLead, deleteLead, getLeadFilters } from './thunk';

export const initialState = {
  crmcontacts: [],
  companies: [],
  deals: [],

  leads: [],
  leadsTotal: 0,
  leadsPage: 1,
  leadsPageLimit: 25,

  leadFilters: [],
  selectedCvid: null,
  leadColumns: [],
  leadFilterName: "",
  selectedCvid: null,

  error: null
};

const getPayloadError = (action) => {
  if (action.payload && typeof action.payload === 'object') {
    return action.payload.error ?? action.payload;
  }
  return action.error?.message ?? null;
};

const crmSlice = createSlice({
  name: "crm",
  initialState,
  reducers: {},
  extraReducers: (builder) => {

    builder.addCase(getContacts.rejected, (state, action) => {
      state.error = getPayloadError(action);
      state.isContactCreated = false;
      state.isContactSuccess = false;
    });

    builder.addCase(addNewContact.fulfilled, (state, action) => {
      state.crmcontacts.unshift(action.payload.data);
      state.isCompaniesCreated = true;
      state.isCompaniesAdd = true;
      state.isCompaniesAddFail = false;
    });

    builder.addCase(addNewContact.rejected, (state, action) => {
      state.error = getPayloadError(action);
      state.isContactAdd = false;
      state.isContactAddFail = true;
    });

    builder.addCase(updateContact.fulfilled, (state, action) => {
      const updatedContact = action.payload?.data;

      if (!updatedContact) {
        state.isContactUpdate = false;
        state.isContactUpdateFail = true;
        state.error = "Invalid contact update response";
        return;
      }

      const updatedId = String(
        updatedContact.id ??
        updatedContact._id ??
        ""
      );

      state.crmcontacts = (state.crmcontacts || []).map((contact) => {
        const contactId = String(
          contact.id ??
          contact._id ??
          ""
        );

        return contactId && contactId === updatedId
          ? {
            ...contact,
            ...updatedContact,
            id: updatedContact.id ?? contact.id,
            _id:
              updatedContact._id ??
              contact._id ??
              updatedContact.id ??
              contact.id,
          }
          : contact;
      });

      state.isContactUpdate = true;
      state.isContactUpdateFail = false;
      state.error = null;
    });

    builder.addCase(updateContact.rejected, (state, action) => {
      state.error = getPayloadError(action);
      state.isContactUpdate = false;
      state.isContactUpdateFail = true;
    });

    builder.addCase(deleteContact.fulfilled, (state, action) => {
      state.crmcontacts = (state.crmcontacts || []).filter((contact) => contact._id.toString() !== action.payload.contact.toString());
      state.isContactDelete = true;
      state.isContactDeleteFail = false;
    });

    builder.addCase(deleteContact.rejected, (state, action) => {
      state.error = getPayloadError(action);
      state.isContactDelete = false;
      state.isContactDeleteFail = true;
    });

    builder.addCase(getCompanies.fulfilled, (state, action) => {
      state.companies = action.payload.data;
      state.isCompaniesCreated = false;
      state.isCompaniesSuccess = true;
    });

    builder.addCase(getCompanies.rejected, (state, action) => {
      state.error = getPayloadError(action);
      state.isCompaniesCreated = false;
      state.isCompaniesSuccess = false;
    });

    builder.addCase(addNewCompanies.fulfilled, (state, action) => {
      state.companies.unshift(action.payload);
      state.isCompaniesCreated = false;
      state.isCompaniesSuccess = true;
    });

    builder.addCase(addNewCompanies.rejected, (state, action) => {
      state.error = getPayloadError(action);
      state.isCompaniesCreated = false;
      state.isCompaniesSuccess = false;
    });


    builder.addCase(updateCompanies.fulfilled, (state, action) => {
      state.companies = state.companies.map(company =>
        company._id === action.payload.data._id ? { ...company, ...action.payload.data } : company);
      state.isCompaniesUpdate = true;
      state.isCompaniesUpdateFail = false;
    });

    builder.addCase(updateCompanies.rejected, (state, action) => {
      state.error = getPayloadError(action);
      state.isCompaniesUpdate = false;
      state.isCompaniesUpdateFail = true;
    });

    builder.addCase(deleteCompanies.fulfilled, (state, action) => {
      state.companies = state.companies.filter(
        company => company._id.toString() !== action.payload.companies.toString());
      state.isCompaniesDelete = true;
      state.isCompaniesDeleteFail = false;
    });

    builder.addCase(deleteCompanies.rejected, (state, action) => {
      state.error = getPayloadError(action);
      state.isCompaniesDelete = false;
      state.isCompaniesDeleteFail = true;
    });

    builder.addCase(getDeals.fulfilled, (state, action) => {
      state.deals = action.payload;
    });

    builder.addCase(getDeals.rejected, (state, action) => {
      state.error = getPayloadError(action);
    });

    

    builder.addCase(getLeads.fulfilled, (state, action) => {
      console.log("Redux Leads Payload:", action.payload);

      const payload = action.payload || {};

      // Leads
      state.leads = Array.isArray(payload.data)
        ? payload.data
        : [];

      // Pagination
      state.leadsTotal = Number(payload.count || 0);
      state.leadsPage = Number(payload.page || 1);
      state.leadsPageLimit = Number(payload.pageLimit || 25);

      // Vtiger Custom Views
      const customFilter = payload.customFilter || {};

      state.leadFilters = Object.values(customFilter)
        .flatMap((group) => {
          if (!group || typeof group !== "object") {
            return [];
          }

          return Object.values(group);
        })
        .filter((filter) => filter && filter.cvid);

      // CVID selected by FetchRecords.php
      if (payload.cvid) {
        state.selectedCvid = Number(payload.cvid);
      }

      console.log("Redux Lead Filters:", state.leadFilters);
      console.log("Redux Selected CVID:", state.selectedCvid);

      state.isLeadsSuccess = true;
      state.isLeadsFail = false;
      state.error = null;
    });

    builder.addCase(getLeads.rejected, (state, action) => {
      console.error("Redux Leads Rejected:", action.payload);

      state.leads = [];
      state.leadsTotal = 0;

      state.isLeadsSuccess = false;
      state.isLeadsFail = true;
    });

    builder.addCase(addNewLead.fulfilled, (state, action) => {
      state.leads.unshift(action.payload.data);
      state.isLeadCreated = true;
      state.isLeadsAdd = true;
      state.isLeadsAddFail = false;
    });

    builder.addCase(addNewLead.rejected, (state, action) => {
      state.error = getPayloadError(action);
      state.isLeadsAdd = false;
      state.isLeadsAddFail = true;
    });

    builder.addCase(updateLead.fulfilled, (state, action) => {
      const updatedLead = action.payload?.data;

      if (!updatedLead) {
        state.isLeadsUpdate = false;
        state.isLeadsUpdateFail = true;
        state.error = "Invalid lead update response";
        return;
      }

      const updatedId = String(
        updatedLead.id ??
        updatedLead._id ??
        ""
      );

      state.leads = (state.leads || []).map((lead) => {
        const leadId = String(
          lead.id ??
          lead._id ??
          ""
        );

        return leadId && leadId === updatedId
          ? {
            ...lead,
            ...updatedLead,
            id: updatedLead.id ?? lead.id,
            _id: updatedLead._id ?? lead._id ?? updatedLead.id ?? lead.id,
          }
          : lead;
      });

      state.isLeadsUpdate = true;
      state.isLeadsUpdateFail = false;
      state.error = null;
    });

    builder.addCase(updateLead.rejected, (state, action) => {
      state.error = getPayloadError(action);
      state.isLeadsUpdate = false;
      state.isLeadsUpdateFail = true;
    });

    builder.addCase(deleteLead.fulfilled, (state, action) => {
      const deletedId = String(
        action.payload?.leads ??
        action.payload?.id ??
        action.payload?._id ??
        ""
      );

      state.leads = (state.leads || []).filter((lead) => {
        const leadId = String(
          lead.id ??
          lead._id ??
          ""
        );

        return leadId !== deletedId;
      });

      state.isLeadsDelete = true;
      state.isLeadsDeleteFail = false;
      state.error = null;
    });

    builder.addCase(deleteLead.rejected, (state, action) => {
      state.error = getPayloadError(action);
      state.isLeadsDelete = false;
      state.isLeadsDeleteFail = true;
    });

    builder.addCase(
      getLeadFilters.fulfilled,
      (state, action) => {

        state.leadFilters =
          Array.isArray(action.payload?.filters)
            ? action.payload.filters
            : [];

      }
    );

    builder.addCase(
      getLeadFilters.rejected,
      (state, action) => {

        state.leadFilters = [];

        state.error = getPayloadError(action);
      }
    );
  },
});

export default crmSlice.reducer;
